export function slugify(value) {
  return String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-") || "proiect";
}

export function categorySlug(category) {
  return slugify(category);
}

export function projectPath(category, slug) {
  return `/proiecte/${categorySlug(category)}/${slugify(slug)}`;
}
